import axios from 'axios';
import lstModules from 'common/json/lstModules.json';


const tokenid = localStorage.getItem("tokenid");
const httpURL = lstModules['main'].url + ":" + lstModules['main'].port + "/sms/reportcard/hpc";

export const getHpcListSvc = (hpcGenerateRQObj, cb) => {
    const obj = { status: "", message: "" };
    // console.log(hpcGenerateRQObj)
    var formData = new FormData();
    formData.append('hpcGenerateRQObj',JSON.stringify(hpcGenerateRQObj));
    axios({
        url: httpURL + '/generate',
        method: "POST",
        headers: { 'tokenid': tokenid },
        data: formData,
        withCredentials: true,
    }).then((response) => {
        // console.log("response in getHpcListSvc", response);
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        if (response.data.SvcStatus === "Success") {
            obj.lstReportCard = response.data.lstReportCard;
            obj.basePathStudent = response.data.basePathStudent;
            obj.basePathActivity = response.data.basePathActivity;
        }
        cb(obj);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error;
        cb(obj);
    })
}
